import { auth } from '../../firebase'

const anonymousLogin = async () => {
  try {
    const authUser = await auth().signInAnonymously()
    return { error: null, authUser }
  } catch (err) {
    window.console.log(err)
    return { error: err }
  }
}

const emailLogin = async (email: string, password: string) => {
  if (!password) {
    auth().sendSignInLinkToEmail(email, {
      handleCodeInApp: true,
      url: '/link-login'
    }).then(() => {
      return { error: null }
    }).catch(reason => {
      window.console.log(reason)
      return { error: {
        message: reason
      } }
    })
  }

  try {
    await auth().signInWithEmailAndPassword(email, password)
    return { error: null }
  } catch (err) {
    window.console.log(err)
    return { error: err }
  }
}

const logout = () => {
  auth().signOut()
}

const register = async (user: { email: string, password: string, [key: string]: any }) => {
  try {
    const authUser = await auth().createUserWithEmailAndPassword(user.email, user.password)
    return { error: null, authUser }
  } catch (err) {
    window.console.log(err)
    return { error: err }
  }
}

const setUser = (user: {[key: string]: any}) => {
  localStorage.setItem('authUser', JSON.stringify(user))
}

export default {
  install: (Vue: Vue.VueConstructor, options: {[key: string]: any}) => {
    Vue.prototype.$auth = { anonymousLogin, emailLogin, logout, register, setUser }
  }
}
